import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store } from "./redux/store";
import { AuthProvider } from "./contexts/AuthProvider/AuthProvider";
import { LinearProgress } from "@mui/material";
import { RolesProvider } from "./security/RolesProvider/RolesProvider";
import { AppConfigProvider } from "./security/ApplicationProvider/ApplicationProvider";
import { BillingCompanyProvider } from "./providers";
import { SocketProvider } from "./contexts/SocketProvider/SocketProvider";
import { NotificationProvider } from "./contexts/NotificationProvider/NotificationProvider";
import { CompanyWalletProvider } from "./views/CompanyWallet/CompanyWalletProvider/CompanyWalletProvider";
import { HelmetProvider } from "react-helmet-async";
import { checkAndClearCache } from "./utils/cacheManager";

checkAndClearCache().then((shouldRender) => {
  if (!shouldRender) return;

  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
  );
  root.render(
    <HelmetProvider>
      <BrowserRouter>
        <Provider store={store}>
          <AppConfigProvider>
            <AuthProvider>
              <RolesProvider>
                <BillingCompanyProvider>
                  <CompanyWalletProvider>
                    <SocketProvider>
                      <NotificationProvider>
                        <Suspense fallback={<LinearProgress />}>
                          <App />
                        </Suspense>
                      </NotificationProvider>
                    </SocketProvider>
                  </CompanyWalletProvider>
                </BillingCompanyProvider>
                {/* <MessageBox /> */}
              </RolesProvider>

            </AuthProvider>
          </AppConfigProvider>
        </Provider>
      </BrowserRouter>
    </HelmetProvider>,
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
});
